// import axios from "axios";
// import ReactDOM from "react-dom";
import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { checkEmpty } from "./GenericFunctions";

// import "../../components/Header/header.css";
// import "../../components/Common/Common.css";
class Carousal extends React.Component {
    render() {
        // refered in https://github.com/YIZHUANG/react-multi-carousel
        const responsive = {
            superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: { max: 4000, min: 3000 },
                items: 5,

            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 3,


            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 2
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1,

            }
        };
        const { clientList } = this.props;
        const filteredList = clientList.filter(fItem => (!checkEmpty(fItem.logo)));
        // Duplicate the list to ensure seamless infinite loop
        const duplicatedList = [...filteredList, ...filteredList, ...filteredList];
        
        return (
            <>
                <Carousel responsive={responsive}
                    autoPlay={true}
                    infinite={true}
                    autoPlaySpeed={2000}
                    keyBoardControl={true}
                    pauseOnHover={false}
                    shouldResetAutoplay={false}
                    arrows={false} 
                    swipeable={true} 
                    showDots={false}
                    transitionDuration={500}
                    removeArrowOnDeviceType={["tablet", "mobile"]}>
                    {duplicatedList.map((item, index) => {
                        return <div key={`${item.accountNo}-${index}`}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%"
                            }}>
                            <img src={item.logo} alt={'Brand'} style={{
                                width: "100px",
                                maxWidth: "100px",
                                minWidth: "100px",
                                height: "auto"
                            }} />
                        </div>
                    })}

                </Carousel>







            </>
        )
    }

} export default (Carousal);